export const base64IsImage = (base64: string) =>
  base64.match(/\/(png|jpg|jpeg|gif|bmp|tiff);/);

export const base64FileToImage = (base64: string) =>
  base64.replace("data:@file", "data:image");
